import { getEstimatedTasksFromCredits } from '@frontend/api-client';

/**
 * Format a task estimate string from a credit amount.
 *
 * @param credits - The number of credits to estimate tasks for
 * @returns Formatted string like "~3-5 tasks" or "~1 task"
 *
 * @example
 * formatTaskEstimate(100) // "~3-5 tasks"
 * formatTaskEstimate(25)  // "~1 task"
 */
export const formatTaskEstimate = (credits: number): string => {
  const estimate = getEstimatedTasksFromCredits(credits);

  if (estimate.min === estimate.max) {
    return `~${estimate.min} task`;
  }

  return `~${estimate.min}-${estimate.max} tasks`;
};
